import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyMembersDetails = lazyWithRetry(() => import('./membersDetails'));
